import React from 'react'
import { Container, Wrapper, Title, Desc, CardContainer } from './ProfessionalCertificateStyle'
import ProfessionalCertificateCard from '../Cards/ProfessionalCertificateCard'
import { professionalCertificates } from '../../data/constants'

const ProfessionalCertificates = () => {
  return (
    <Container id="certificates">
      <Wrapper>
        <Title>Professional Certificates</Title>
        <Desc>
          Selected professional certificates relevant to software engineering, infrastructure, DevOps, AI productivity, and technical leadership.
        </Desc>
        <CardContainer>
          {professionalCertificates
            .map((certificate, index) => (
              <ProfessionalCertificateCard certificate={certificate} key={index} />
            ))}
        </CardContainer>
      </Wrapper>
    </Container>
  )
}

export default ProfessionalCertificates
